export default "__VITE_ASSET__Iup5DBqC__"